@if (loading) {
  <mat-progress-spinner
    diameter="24"
    mode="indeterminate"></mat-progress-spinner>
}

@if (transactionLoadFailed) {
  <div class="transactional-email-error" role="alert">
    Transactional email options could not be loaded. Saving is disabled when
    this gym already has configured transactional email recipients to avoid
    changing them without showing the available transaction types.
  </div>
}

@if (unavailableConfiguredTransactionNames.length > 0) {
  <div class="transactional-email-error" role="alert">
    Transactional email recipients are configured for unavailable transaction
    types: {{ unavailableConfiguredTransactionNames.join(', ') }}. Saving is
    disabled until the available transactions and the gym data match.
  </div>
}

<input
  class="transactional-email-validation-blocker"
  type="text"
  name="transactionalEmailConfigurationStatus"
  required
  [ngModel]="transactionalEmailConfigurationStatus"
  aria-hidden="true"
  tabindex="-1" />

@for (transaction of emailSendingTransactions; track transaction) {
  <mat-card class="transactional-email-subsection">
    <mat-toolbar class="toolbar-subtitle transactional-email-toolbar">
      <mat-toolbar-row class="transactional-email-header">
        Recipients for emails of the {{ transaction }} transactions
        <button
          mat-mini-fab
          color="default"
          type="button"
          matTooltip="Add recipient email"
          [disabled]="!editMode"
          (click)="addRecipient(transaction)">
          <mat-icon color="secondary" aria-label="Add recipient">add</mat-icon>
        </button>
      </mat-toolbar-row>
    </mat-toolbar>

    <mat-card-content class="recipient-list">
      @for (
        recipient of getRecipients(transaction);
        track $index;
        let i = $index
      ) {
        <div class="recipient-row">
          <mat-form-field class="recipient-field">
            <mat-label>Recipient email</mat-label>
            <input
              matInput
              required
              email
              type="email"
              #recipientInput="ngModel"
              placeholder="Recipient email"
              [ngModel]="recipient"
              (ngModelChange)="setRecipient(transaction, i, $event)"
              [name]="'transactionalEmail-' + transaction + '-' + i"
              [id]="'transactionalEmail-' + transaction + '-' + i"
              [disabled]="!editMode" />
            @if (recipientInput.errors?.['required']) {
              <mat-error>Email is required</mat-error>
            }
            @if (recipientInput.errors?.['email']) {
              <mat-error>Invalid email</mat-error>
            }
          </mat-form-field>

          <button
            mat-icon-button
            color="warn"
            type="button"
            matTooltip="Remove recipient"
            [disabled]="!editMode"
            (click)="removeRecipient(transaction, i)">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      }

    </mat-card-content>
  </mat-card>
}
